//*******************************************************
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//*******************************************************
// Components
import { ComhomeComponent }                 from './components/comhome/comhome.component';
import { ComeventprofilesComponent }        from './components/comeventprofiles/comeventprofiles.component';

import { CominviteedetailComponent }        from './components/cominviteedetail/cominviteedetail.component';
import { CominviteeinviteComponent }        from './components/cominviteeinvite/cominviteeinvite.component';
import { CominviteegiftregisterComponent }  from './components/cominviteegiftregister/cominviteegiftregister.component';
import { CominviteersvpComponent }          from './components/cominviteersvp/cominviteersvp.component';
import { CominviteeseatingComponent }       from './components/cominviteeseating/cominviteeseating.component';
import { CominviteegiftthankyouComponent }  from './components/cominviteegiftthankyou/cominviteegiftthankyou.component';

import { ComtodoComponent }                 from './components/comtodo/comtodo.component';

import { ComappointmentComponent }          from './components/comappointment/comappointment.component';

import { ComfinanceComponent }              from './components/comfinance/comfinance.component';

import { ComtodolistsnapshotComponent }     from './components/comtodolistsnapshot/comtodolistsnapshot.component';

import { ComappointmentsnapshotComponent }  from './components/comappointmentsnapshot/comappointmentsnapshot.component';

import { CominviteesnapshotComponent }      from './components/cominviteesnapshot/cominviteesnapshot.component';

import { CommfinancesnapshotComponent }     from './components/commfinancesnapshot/commfinancesnapshot.component';

import { ComadminComponent }                from './components/comadmin/comadmin.component';
import { ComfaqComponent }                  from './components/comfaq/comfaq.component';
//*******************************************************
const routes: Routes = [
                          { path: 'comphome/:formheight',                           component: ComhomeComponent },
                          { path: 'compeventprofile/:eventid/:formheight',          component: ComeventprofilesComponent },

                          { path: 'cominviteedetail/:eventid/:formheight',          component: CominviteedetailComponent },
                          { path: 'cominviteeinvite/:eventid/:formheight',          component: CominviteeinviteComponent },
                          { path: 'cominviteegiftregister/:eventid/:formheight',    component: CominviteegiftregisterComponent },
                          { path: 'cominviteersvp/:eventid/:formheight',            component: CominviteersvpComponent },
                          { path: 'cominviteeseating/:eventid/:formheight',         component: CominviteeseatingComponent },
                          { path: 'cominviteegiftthankyou/:eventid/:formheight',    component: CominviteegiftthankyouComponent },

                          { path: 'comtodo/:eventid/:formheight',                   component: ComtodoComponent },

                          { path: 'comappointment/:eventid/:formheight',            component: ComappointmentComponent },

                          { path: 'comfinance/:eventid/:formheight',                component: ComfinanceComponent },

                          { path: 'comtodolistsnapshot/:eventid/:formheight',       component: ComtodolistsnapshotComponent },
                          { path: 'comappointmentsnapshot/:eventid/:formheight',    component: ComappointmentsnapshotComponent },
                          { path: 'compguestsnapshot/:eventid/:formheight',         component: CominviteesnapshotComponent },
                          { path: 'compfinancesnapshot/:eventid/:formheight',       component: CommfinancesnapshotComponent },

                          { path: 'propdocadmin/:formheight',                       component: ComadminComponent,
                            children:
                                [
                                  { path: 'faqadmin/:formheight', component: ComfaqComponent }
                                ]

                          },

                          { path: 'faqadmin/:formheight', component: ComfaqComponent }
                      ];
//*******************************************************
@NgModule (
            {
                imports: 
                  [
                    RouterModule.forRoot(routes)
                  ],

                exports: 
                  [
                    RouterModule
                  ]
            }
            
          )
//*******************************************************
export class AppRoutingModule { }
//*******************************************************

